<template>
  <div class="widget">
    <h3>校内活动
      <router-link to="/activity" class="more">更多&gt;</router-link>
    </h3>
    <ul>
      <li v-for="item in tableData" :key="item.activity_id">
        <router-link :to="`/activitycontent/${item.activity_id}`" class="w-title">{{ item.activity_title }}</router-link>
        <div class="w-meta">
          <span class="icon">📍</span>{{ item.activity_locale }}
          <span class="read"><span class="icon">👁</span>{{ item.activity_read_num }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { getActivityList } from '@/api'

export default {
  name: 'ActivityWidget',
  data() {
    return { tableData: [] }
  },
  created() {
    getActivityList({ page: 1, pagesize: 5 }).then((res) => {
      this.tableData = res.data || []
    })
  }
}
</script>
